import React, { useEffect } from "react"
import Layout from "~/components/Layout";
import { useLang } from "~/hooks/useLang";
import AuditPrintOccurrenceTable from "../components/PrintOccurrence";

export default function AuditPrintOccurrence() {
    const { translate } = useLang();

    useEffect(() => {
        document.title = translate('User Actions report Audit - Dispatch System')
    }, [])
    return (
        <Layout marginLayout={true}>
            <AuditPrintOccurrenceTable />
        </Layout>
    )
}